import { Box, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { get, lowerCase } from 'lodash'
import { getNativeName } from 'Helpers/GlobalHelpers'
import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { ReactComponent as ArrowRightIcon } from './assets/ArrowRightIcon.svg'
import { ReactComponent as ArrowLeftIcon } from './assets/ArrowLeftIcon.svg'
import storeAuth from 'GlobalStores/User/StoreAuth'
import { useState } from 'react'
import AchievementModal from '../Achievements/AchievementModal'

const GenealogyCardItemName = observer(({ item, index, handleFetchDownline, isDownline, handleGoBack, achievementHistory, periodIndex }) => {
    const translate = useTranslate()
    const [openModal, setOpenModal] = useState(false)

    const isFirst = index === 0
    const isLoggedInUser = item.customer.id.unicity === storeAuth.GetId()
    const hasDownLine = item.customer.sponsoredCustomers === null ? false : true
    const isHasDownLineAndNotLoginUser = (hasDownLine && isLoggedInUser === false) || (isLoggedInUser === false && index === 0)

    const bgColor = index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'
    const fontWeight = index === 0 ? 600 : 400

    const fullNameEn = get(item, 'customer.humanName.fullName', '')
    const fullNameNative = getNativeName(get(item, 'customer.humanName', ''))

    const rankTranslateKey = `${lowerCase(get(item, 'customer.cumulativeMetricsProfile.highestRankShort', '')).replace(/ /g, '')}_rank`

    const showTerminateText = () => {
        if (['Terminated', 'Suspended', 'Retired'].includes(get(item, 'customer.status', ''))) {
            return translate('suspended')
        }
        return ''
    }

    const findLegBadge = legName => {
        if (!achievementHistory.items[periodIndex]?.metricsDetails[legName]) return null
        const leg = achievementHistory.items[periodIndex]?.metricsDetails[legName]?.customers.find(
            customer => customer.customer.id.unicity === item.customer.id.unicity
        )
        return leg ? legName : null
    }

    const LegBadge = () => {
        const leg1 = findLegBadge('ov_leg1')
        const leg2 = findLegBadge('ov_leg2')
        const legApt = findLegBadge('apt')

        const legBadges = leg1 || leg2 || legApt || null

        if (!legBadges) {
            return null
        }

        let legName = ''
        if (legBadges === 'ov_leg1') legName = 'Leg 1'
        if (legBadges === 'ov_leg2') legName = 'Leg 2'
        if (legBadges === 'apt') legName = 'AFP'

        return (
            <Box
                sx={{
                    backgroundColor: '#FFA001',
                    borderRadius: '3px',
                    padding: '0px 4px',
                    width: 'fit-content',
                    height: '15px',
                    justifyContent: 'center'
                }}>
                <Typography fontFamily={'Poppins'} fontSize={'10px'} color="#ffffff" fontWeight={fontWeight}>
                    {legName}
                </Typography>
            </Box>
        )
    }

    return (
        <Stack
            key={item.customer.id.unicity}
            sx={{ backgroundColor: bgColor, minHeight: '55px', height: '63px', borderBottom: '1px solid #D1D9E2', overflow: 'hidden' }}
            justifyContent={'center'}>
            <Stack
                direction={isFirst && !isDownline ? 'column' : 'row'}
                alignItems={isFirst && !isDownline ? 'flex-start' : 'center'}
                gap={isFirst && !isDownline ? 0 : '12px'}>
                {isFirst && isDownline && (
                    <Stack
                        sx={{
                            cursor: 'pointer',
                            paddingLeft: '16px'
                        }}
                        onClick={handleGoBack}>
                        <ArrowLeftIcon />
                    </Stack>
                )}
                {!isFirst && (
                    <Stack
                        sx={{
                            visibility: isHasDownLineAndNotLoginUser ? 'inherit' : 'hidden',
                            display: isLoggedInUser ? 'none' : 'inherit',
                            cursor: 'pointer',
                            paddingLeft: '24px'
                        }}
                        onClick={() => handleFetchDownline(item.customer.id.unicity)}>
                        <ArrowRightIcon />
                    </Stack>
                )}
                <Stack sx={{ paddingLeft: isFirst && !isDownline ? '24px' : '0px' }}>
                    <Stack direction={'row'} gap={'12px'} alignItems={'center'}>
                        <Typography
                            fontFamily={'Inter, Poppins, NotoSansThai'}
                            fontSize={'16px'}
                            color="#5A8FC3"
                            fontWeight={fontWeight}
                            whiteSpace={'nowrap'}
                            sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                            onClick={() => setOpenModal(true)}>
                            {StoreTranslate.CurrentLanguage() === 'EN' ? fullNameEn : fullNameNative}
                        </Typography>
                        <LegBadge />
                    </Stack>
                    <Stack direction={'row'}>
                        <Typography fontFamily={'Inter'} fontSize={'12px'} color="#384250" fontWeight={fontWeight}>
                            {get(item, 'customer.id.unicity', '')}
                        </Typography>
                        {showTerminateText() && (
                            <Typography fontFamily={'Inter'} fontSize={'12px'} fontWeight={fontWeight} color="#FE5D7C">
                                &nbsp;-&nbsp;{showTerminateText()}
                            </Typography>
                        )}
                        <Typography fontFamily={'Inter'} fontSize={'12px'} color="#384250" fontWeight={fontWeight}>
                            &nbsp;-&nbsp;{translate(rankTranslateKey)}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>

            {/* Achievement Modal */}
            <AchievementModal open={openModal} onClose={() => setOpenModal(false)} customerId={item.customer.id.unicity} />
        </Stack>
    )
})

export default GenealogyCardItemName
